<div style="text-align: center; min-width: 300px">
  <div mat-dialog-content>
    <lemon-dialog-header>Tositteen tuonti käynnistettiin uudelleen</lemon-dialog-header>

    Tuonti käynnistettiin uudelleen luomalla seuraava työjonoentry Lemonaidiin:
    <div>
      <a [href]="uriEncoded" target="_BLANK">{{ uri }}</a>
    </div>
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-primary-button mat-dialog-close actionId="Dialog: tositteen tuonti käynnistetty uudelleen">OK</app-primary-button>
  </div>
</div>
